import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('buried_treasure', {
  cherry: 'gold_coin',
  lemon: 'gem_cluster',
  orange: 'goblet',
  bell: 'pirate_crown',
  star: 'treasure_x_wild',
  seven: 'jewelled_dagger',
  gem: 'ruby',
  scatter: 'golden_idol_scatter',
  money: 'overflowing_chest',
});

/** Buried Treasure — GENERATED by scaffoldSlot from
 *  content/slots/buried_treasure.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const BURIED_TREASURE_THEME: Theme = {
  id: 'buried_treasure',
  name: 'Buried Treasure',
  palette: {
    accent: 0xe8b53a,
    secondary: 0xb8742a,
    warm: 0xf6dd92,
    frameFill: 0x2a1c10,
    bgGradientTop: 0x3e2a16,
    bgGradientBottom: 0x140b06,
    dimOverlay: 0x0a0704,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Gold Coin', glyph: '🪙', tint: 0xf0c860, weight: 5, textureAlias: 'buried_treasure:cherry',
        winVideoAlias: 'buried_treasure:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Gem Cluster', glyph: '💎', tint: 0xd44a8a, weight: 5, textureAlias: 'buried_treasure:lemon',
        winVideoAlias: 'buried_treasure:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Goblet', glyph: '🍷', tint: 0xe8b53a, weight: 4, textureAlias: 'buried_treasure:orange',
        winVideoAlias: 'buried_treasure:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Pirate Crown', glyph: '👑', tint: 0xf0c860, weight: 3, textureAlias: 'buried_treasure:bell',
        winVideoAlias: 'buried_treasure:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Treasure X', glyph: '❌', tint: 0xf6dd92, weight: 2, textureAlias: 'buried_treasure:star',
        winVideoAlias: 'buried_treasure:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Jewelled Dagger', glyph: '🗡️', tint: 0xe0b84a, weight: 2, textureAlias: 'buried_treasure:seven',
        winVideoAlias: 'buried_treasure:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Ruby', glyph: '💎', tint: 0xd23a4a, weight: 2.5, textureAlias: 'buried_treasure:gem',
        winVideoAlias: 'buried_treasure:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Golden Idol', glyph: '🗿', tint: 0xe8b53a, weight: 0.5, textureAlias: 'buried_treasure:scatter',
        winVideoAlias: 'buried_treasure:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Overflowing Chest', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'buried_treasure:money',
        winVideoAlias: 'buried_treasure:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a1c10, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xe8b53a, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf6dd92, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xb8742a, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xe8b53a, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf6dd92, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf6dd92, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a1c10, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xb8742a, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xe8b53a, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf6dd92, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf6dd92, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'buried_treasure:bg', path: 'environment/buried_treasure.png' },
      columnBackground: { alias: 'buried_treasure:column_bg', path: 'reel/buried_treasure_column_bg.png' },
      border: { alias: 'buried_treasure:border', path: 'brand/border_underwater.png' },
    },
  },
};
